import Reveal from "@/components/feature/Reveal";
import { timelineList } from "@/mocks/homeContent";

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-background-50">
      <div className="mx-auto w-full max-w-page px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-[30px]">
              从傍晚到深夜，吃瓜节奏表
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">
              什么时候出新料、什么时候等回应、什么时候适合复盘，按这个节奏走基本不会漏。
            </p>
          </div>
        </Reveal>

        <div className="relative mt-10 pl-6 md:pl-0">
          <div className="absolute bottom-0 left-[7px] top-2 w-px bg-background-300 md:left-1/2 md:-translate-x-1/2" />
          <div className="flex flex-col gap-8 md:gap-10">
            {timelineList.map((item, index) => (
              <Reveal key={item.time} delay={index * 80}>
                <div
                  className="relative md:grid md:grid-cols-2 md:gap-10"
                >
                  <span className="absolute -left-6 top-1.5 flex h-4 w-4 items-center justify-center md:left-1/2 md:-translate-x-1/2">
                    <span className="h-3.5 w-3.5 rounded-full border-2 border-background-50 bg-accent-500" />
                  </span>

                  {index % 2 === 0 ? (
                    <>
                      <div className="rounded-lg border border-background-200 bg-background-100/60 p-4 md:p-5 md:text-right">
                        <p className="font-heading text-sm font-semibold text-accent-600">{item.time}</p>
                        <h3 className="mt-1.5 text-base font-medium text-foreground-950">{item.title}</h3>
                        <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                      </div>
                      <div className="hidden md:block" />
                    </>
                  ) : (
                    <>
                      <div className="hidden md:block" />
                      <div className="rounded-lg border border-background-200 bg-background-100/60 p-4 md:p-5">
                        <p className="font-heading text-sm font-semibold text-accent-600">{item.time}</p>
                        <h3 className="mt-1.5 text-base font-medium text-foreground-950">{item.title}</h3>
                        <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                      </div>
                    </>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}